import React from "react";
import { useHistory } from "react-router-dom";
import * as S from "./styles";
import { ISupplier } from "interfaces/supplier";
import { cnpj } from "utils";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";

interface IGridSupplierProps {
  supplier: ISupplier[] | Record<string, any>[];
}

interface IsupplierProps {
  supplier: ISupplier | Record<string, any>;
}

const Item: React.FC<IsupplierProps> = ({ supplier }) => {
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  const havePermission = checkUserPermission("editSupplier");
  return (
    <S.ItemContainer
      onClick={() =>
        havePermission && history.push(`/settings/supplier/${supplier.id}`)
      }
    >
      <S.ItemContent pointer={havePermission}>
        <S.ItemValue>{supplier.code || "--"}</S.ItemValue>
        <S.ItemValue>{supplier.cnpj ? cnpj(supplier.cnpj) : "--"}</S.ItemValue>
        <S.ItemValue>{supplier?.trade_name || supplier?.company_name || "--"}</S.ItemValue>
        {havePermission && (
          <S.ButtonDetail>
            <S.IconDetail />
          </S.ButtonDetail>
        )}
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridSupplier: React.FC<IGridSupplierProps> = ({
  supplier = [],
}) => {
  const { getTranslation } = useTranslation(translations);

  return (
    <S.Container>
      <S.Header>
        <S.Label>{getTranslation("codigo")}</S.Label>
        <S.Label>{getTranslation("cnpj")}</S.Label>
        <S.Label>{getTranslation("nomeFantasia")}</S.Label>
      </S.Header>
      {supplier.length > 0 &&
        supplier.map((supplier) => (
          <Item supplier={supplier} key={supplier.id} />
        ))}
    </S.Container>
  );
};
